import React, { memo, forwardRef } from "react";
const SvgCapitalB = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.29 14.68h2.24c.84 0 1.48-.167 1.92-.5.44-.333.66-.807.66-1.42 0-.64-.227-1.093-.68-1.36-.453-.267-1.16-.4-2.12-.4h-2.02v3.68zm0 6.28h2.26c.32 0 .667-.02 1.04-.06a3.492 3.492 0 001.02-.3c.32-.147.58-.36.78-.64.213-.28.32-.653.32-1.12 0-.747-.253-1.267-.76-1.56-.507-.293-1.273-.44-2.3-.44h-2.36v4.12zm-1.02 2.12c-1 0-1.5-.5-1.5-1.5V10.42c0-1 .5-1.5 1.5-1.5h4.02c.533 0 1.06.067 1.58.2.52.12.98.327 1.38.62.413.28.747.647 1 1.1.253.453.38 1 .38 1.64 0 .8-.227 1.46-.68 1.98-.453.52-1.047.893-1.78 1.12v.04c.893.12 1.627.467 2.2 1.04.573.573.86 1.34.86 2.3 0 .773-.153 1.427-.46 1.96-.307.52-.713.94-1.22 1.26a5.24 5.24 0 01-1.72.7c-.64.133-1.293.2-1.96.2h-3.6z"
      />
    </svg>
  );
});
SvgCapitalB.displayName = "SvgCapitalB";
const MemoForwardRef = memo(SvgCapitalB);
export default MemoForwardRef;
